import { useAuth } from "@/hooks/useAuth";
import { Role } from "@/enums/role";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { appActions } from "@/redux/actions/app.actions";
import { useDispatch } from "@/redux/store";

interface AdminRouteWrapperProps {
  children: ReactNode;
}

export const AdminRouteWrapper = ({ children }: AdminRouteWrapperProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, user } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      const fullUrl = `${location.pathname}${location.search}${location.hash}`;
      dispatch(appActions.setAppState({ redirectTo: fullUrl }));
      navigate("/");
      return;
    }

    const isAdmin = user?.role === Role.ADMIN || user?.role === Role.CREATOR;
    if (!isAdmin) {
      navigate("/dashboard");
    }
  }, [navigate, isAuthenticated, dispatch, location, user]);

  if (!isAuthenticated || !user) return null;
  if (user.role !== Role.ADMIN && user.role !== Role.CREATOR) return null;

  return <>{children}</>;
};
